import { put, takeEvery } from 'redux-saga/effects';
import { removeCmsBanner, removeBanner } from 'features/Banners/Banners.reducer';
import { OFFER_BANNER_ID } from 'constants/promotions';

export function* removeOfferBanner() {
  yield put(removeBanner(OFFER_BANNER_ID));
}

export function* watchOfferBannerSaga(client) {
  yield takeEvery(removeCmsBanner().type, removeOfferBanner, client);
}
